
// @ts-nocheck
import locale_en_46yml_98f2e049 from "#nuxt-i18n/98f2e049";
import locale_sl_46yml_fdd3e584 from "#nuxt-i18n/fdd3e584";

export const localeCodes =  [
  "en",
  "sl"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46yml_98f2e049",
      load: () => Promise.resolve(locale_en_46yml_98f2e049),
      cache: true
    }
  ],
  sl: [
    {
      key: "locale_sl_46yml_fdd3e584",
      load: () => Promise.resolve(locale_sl_46yml_fdd3e584),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en",
      name: "English",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/en.yml",
          cache: undefined
        }
      ]
    },
    {
      code: "sl",
      language: "sl",
      name: "Slovenščina",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/sl.yml",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_lang",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    name: "English",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/en.yml",
        cache: undefined
      }
    ]
  },
  {
    code: "sl",
    language: "sl",
    name: "Slovenščina",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/sl.yml",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/